import "./ProductGrid.less";
import React from "react";

export const ProductGrid: React.FC = ({ children }) => {
  return <div className="product-grid">{children}</div>;
};
